import { render } from "./PurchaseBy.vue?vue&type=template&id=345c97c5"
import script from "./PurchaseBy.vue?vue&type=script&lang=js"
export * from "./PurchaseBy.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__